import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, Grid } from '@material-ui/core';
import { JobTable } from '../JobsList/components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '5px'
  },
  companySpace: {},
  logo: {
    width: 150,
    height: 150,
    margin: 14
  },
  nameCompany: {
    textAlign: 'center',
    marginBottom: 20
  },
  extraInfo: {
    marginTop: 5,
    marginBottom: 5
  },
  iconsHelper: {
    marginBottom: -3
  }
}));

const PlanPackageView = ({
  company,
  fileLogoURL,
  jobToPreview,
  isPreview,
  jobResults,
  showOnTopDemo,
  showMyLogo,
  highlightWithYellow,
  brandColor,
  highlightWithBrandColor
}) => {
  const classes = useStyles();
  const getIntroAnimation = () => {
    return ' animate__animated animate__fadeIn';
  };
  const jobToPreviewResult = {
    job: jobToPreview,
    file: { publicUrl: fileLogoURL },
    company: company,
    showMyLogo,
    showOnTopDemo,
    highlightWithYellow,
    brandColor,
    highlightWithBrandColor
  };
  const addPreviewJob = (jobs) => {
    const copyJobs = [...jobs];
    copyJobs.splice(showOnTopDemo ? 0 : 3, 0, jobToPreviewResult);
    const sampleOfDemo = [...copyJobs];
    sampleOfDemo.splice(7, sampleOfDemo.length - 1);
    return sampleOfDemo;
  };
  const jobsToLoad = addPreviewJob(jobResults);
  return (
    <Card className={classes.root + getIntroAnimation()} elevation={1}>
      <Grid container direction="column" spacing={1} alignItems="center">
        <Grid item>
          <JobTable
            fileLogoURLPreview={fileLogoURL}
            jobToPreviewResult={jobToPreviewResult}
            jobResults={jobsToLoad}
            isPreview={isPreview}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default PlanPackageView;
